import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromoDetailsClickAction } from '../../actions/analytics';
import { openPromoDetails } from '../../actions/promoDetails';
import { PromoItem } from '../../components/PromoItem';
import { SearchResultsItem } from '../../components/SearchResults';
import { selectPromoById } from '../../selectors/promos/promos';
import { TThunkDispatch } from '../../types/redux/thunk';

interface IPromoItemContainerProps {
  promoId: string;
}

export const PromoItemContainer = ({ promoId }: IPromoItemContainerProps) => {
  const promo = useSelector(selectPromoById(promoId));
  const dispatch: TThunkDispatch = useDispatch();

  const openPromoDetailsModal = React.useCallback(() => {
    dispatch(openPromoDetails(promoId));
    dispatch(trackPromoDetailsClickAction(promoId));
  }, [dispatch, promoId]);

  return (
    <SearchResultsItem onClick={openPromoDetailsModal}>
      <PromoItem
        author={promo.providerName}
        authorLogo={promo.providerLogo}
        description={promo.activeDateToText}
        name={promo.promoName}
        newbuildingCount={promo.newbuildingCountText}
        type={promo.promoTypeText}
      />
    </SearchResultsItem>
  );
};
